import { FC, useState } from 'react';
import { createRoot } from 'react-dom/client';
import CrossSellForm from '@forms/CrossSellForm/CrossSellForm';
import Modal from '@components/Modal/Modal';
import createReactModalMount from '@functions/createReactModalMount';
import closeModal from '@functions/closeReactModal';
import { tablet } from '@variables/mediaBreakpoints';
import ModalMount from '@type/ModalMount';

const CrossSell: FC<ModalMount> = ({ mount, root }) => {
    const [open, setOpen] = useState(true);

    return (
        <Modal
            isOpen={open}
            className={'lg:tw-w-full lg:tw-max-w-screen-lg'}
            onClose={() =>
                closeModal({
                    domElement: mount,
                    appRoot: root,
                    closeAction: setOpen,
                })
            }
            modalCloseButtonTestingId={'button--modal-close'}
            appElement={mount}
        >
            <CrossSellForm />
        </Modal>
    );
};

window.addEventListener('DOMContentLoaded', () => {
    const crossSellTriggers = Array.from(
        document.querySelectorAll('[data-form-trigger="cross-sell"]')
    ) as HTMLElement[];

    crossSellTriggers.forEach((trigger) => {
        trigger.addEventListener('click', (e) => {
            e.preventDefault();
            if (trigger.dataset.ls) {
                window.formInfo.ls = trigger.dataset.ls;
            }
            if (trigger.dataset.ss) {
                window.formInfo.ss = trigger.dataset.ss;
            }
            if (trigger.dataset.cid) {
                window.formInfo.cid = trigger.dataset.cid;
            }
            const modal = createReactModalMount('cross-sell-form-modal');
            const crossSellRoot = createRoot(modal);
            crossSellRoot.render(<CrossSell mount={modal} root={crossSellRoot} />);
        });
    });
});
